// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var FileLoader = require("./FileLoader");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.res.js");
var MM_react_common = require("../ui-utils/MM_react_common.res.js");
var Expln_React_Modal = require("../../rescript-utils/main/react-components/Expln_React_Modal.res.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.res.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.res.js");
var Paper = require("@mui/material/Paper").default;
var Expln_utils_promise = require("../../rescript-utils/main/Expln_utils_promise.res.js");
var Button = require("@mui/material/Button").default;
var Checkbox = require("@mui/material/Checkbox").default;
var FormControlLabel = require("@mui/material/FormControlLabel").default;

function loadFile(url, onProgress, onReady, onError) {
  var prim1 = Belt_Option.getWithDefault(onProgress, (function (param, param$1) {
          
        }));
  var prim3 = Belt_Option.getWithDefault(onError, (function (param) {
          
        }));
  FileLoader.loadFile(url, prim1, onReady, prim3);
}

function loadFileWithProgress(modalRef, showWarning, onUrlBecomesTrusted, url, progressText, onReady, onError, transformErrorMsg, onTerminated) {
  var isTerminated = {
    contents: false
  };
  var makeActTerminate = function (modalId) {
    return function () {
      isTerminated.contents = true;
      if (onTerminated !== undefined) {
        onTerminated();
      }
      Expln_React_Modal.closeModal(modalRef, modalId);
    };
  };
  var actDownloadFile = function () {
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                return MM_react_common.rndProgress(progressText, 0, undefined);
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                    return MM_react_common.rndProgress(progressText, 0, makeActTerminate(modalId));
                  }));
            loadFile(url, (function (loaded, total) {
                    var pct = loaded / total;
                    Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                            return MM_react_common.rndProgress(progressText, pct, makeActTerminate(modalId));
                          }));
                  }), (function (text) {
                    if (!isTerminated.contents) {
                      Expln_React_Modal.closeModal(modalRef, modalId);
                      return onReady(text);
                    }
                    
                  }), (function (msg) {
                    Expln_React_Modal.closeModal(modalRef, modalId);
                    if (onError !== undefined) {
                      onError(msg);
                    }
                    if (transformErrorMsg !== undefined) {
                      Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                                  return null;
                                })), (function (modalId) {
                              Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                                      return React.createElement(Paper, {
                                                  style: {
                                                    padding: "10px"
                                                  },
                                                  children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                                                            spacing: 1,
                                                            children: Caml_option.some(null)
                                                          }, transformErrorMsg(msg), React.createElement(Button, {
                                                                onClick: (function (param) {
                                                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                                                  }),
                                                                variant: "contained",
                                                                children: "Ok"
                                                              })))
                                                });
                                    }));
                            }));
                      return ;
                    }
                    
                  }));
          }));
  };
  var dontAskAgain = {
    contents: false
  };
  var actShowWarning = function () {
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                    return React.createElement(Paper, {
                                style: {
                                  padding: "10px"
                                },
                                children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                                          spacing: 1,
                                          children: Caml_option.some(null)
                                        }, React.createElement("span", {
                                              style: {
                                                fontWeight: "bolder"
                                              }
                                            }, "Do you confirm downloading data from the below URL?"), React.createElement("span", undefined, url), React.createElement(FormControlLabel, {
                                              control: React.createElement(Checkbox, {
                                                    onChange: Expln_React_common.evt2bool(function (checked) {
                                                          dontAskAgain.contents = checked;
                                                        })
                                                  }),
                                              label: "don't ask for this URL"
                                            }), React.createElement(Expln_React_Row.make, {
                                              children: Caml_option.some(null)
                                            }, React.createElement(Button, {
                                                  onClick: (function (param) {
                                                      if (dontAskAgain.contents) {
                                                        onUrlBecomesTrusted(url);
                                                      }
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                      actDownloadFile();
                                                    }),
                                                  variant: "contained",
                                                  children: "Confirm"
                                                }), React.createElement(Button, {
                                                  onClick: (function (param) {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                    }),
                                                  variant: "outlined",
                                                  children: "Cancel"
                                                }))))
                              });
                  }));
          }));
  };
  if (showWarning) {
    return actShowWarning();
  } else {
    return actDownloadFile();
  }
}

exports.loadFile = loadFile;
exports.loadFileWithProgress = loadFileWithProgress;
/* react Not a pure module */
